import { useEffect, useState } from "react";
import {
  CardHeader,
  Dialog,
  Box,
  Stepper,
  Step,
  StepLabel,
} from "../../../../../components";
import ImportarCsvStepper from "./importar-csv-stepper.component";
import { ConfiguracoesService } from "../../../../../services";

const ImportarCsvDialog = ({
  openImportarCSVDialog,
  setOpenImportarCSVDialog,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [steps /* setSteps */] = useState(["Selecionar Arquivo", "Produtos"]);
  const [obrigadoriedadeCnpjCpf, setObrigatoriedadeCnpjCpf] = useState(false);
  const [arquivoCsv, setArquivoCsv] = useState(null);
  const configuracoesService = new ConfiguracoesService();

  useEffect(() => {
    if (openImportarCSVDialog) {
      buscaConfiguracoes();
    }
  }, [openImportarCSVDialog]);

  function initCsvClose() {
    setArquivoCsv(null);
    setActiveStep(0);
    setOpenImportarCSVDialog(false);
  }

  async function buscaConfiguracoes() {
    const configuracoes = await configuracoesService.get();
    if (configuracoes.data.count) {
      setObrigatoriedadeCnpjCpf(
        configuracoes.data.rows[0].obrigatoriedadeCnpjCpf
      );
    }
  }

  return (
    <Dialog
      maxWidth="xl"
      fullWidth
      open={openImportarCSVDialog}
      onClose={initCsvClose}
    >
      <CardHeader title="Importar CSV" className="m-2" />
      <Box className="d-flex flex-column align-items-center w-100">
        <Stepper activeStep={activeStep}>
          {steps.map((step) => (
            <Step key={step}>
              <StepLabel>{step}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <ImportarCsvStepper
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          setOpenImportarCSVDialog={setOpenImportarCSVDialog}
          arquivoCsv={arquivoCsv}
          setArquivoCsv={setArquivoCsv}
          obrigadoriedadeCnpjCpf={obrigadoriedadeCnpjCpf}
        />
      </Box>
    </Dialog>
  );
};

export default ImportarCsvDialog;
